module.exports = __webpack_public_path__ + "img/ViewsIcon.06ee59f4.svg";